import { render, staticRenderFns } from "./Parenquima.vue?vue&type=template&id=733998bb"
import script from "./Parenquima.vue?vue&type=script&lang=js"
export * from "./Parenquima.vue?vue&type=script&lang=js"
import style0 from "./Parenquima.vue?vue&type=style&index=0&id=733998bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports